import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllAccount (params) { // 查询所有账户
    return axios.post(global.IMS_INFO + '/account/findAllAccount', params);
  },
  accountUpdate (params) {
    return axios.post(global.IMS_INFO + '/account/updateAccount', params)
  },
  accountDelete (params) {
    return axios.post(global.IMS_INFO + '/account/deleteAccount', params)
  },
  accountShutdown (params) {
    return axios.post(global.IMS_INFO + '/account/shutdownAccount', params)
  },
  accountRestore (params) {
    return axios.post(global.IMS_INFO + '/account/recoverAccount', params)
  },
  accountInsert (params) {
    return axios.post(global.IMS_INFO + '/account/insertAccount', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/ims/account.js